import { useContext } from "react";
import { ReminderContext } from "../contexts/ReminderContext";
import { IReminderContext } from "../contexts/models/IReminderContext.ts";

export const useReminder = () => useContext<IReminderContext>(ReminderContext);